import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  init() {
    gsap.registerPlugin(ScrollTrigger);
    this.setupScrollTriggers();
    window.addEventListener('resize', this.handleResize.bind(this));
  },

  setupScrollTriggers() {
    const progressBar = document.querySelector('.progress-bar');
    const svgContainer = document.querySelector('.svgContainer');
    const asset1 = document.querySelector('.asset1');
    const asset2 = document.querySelector('.asset2');
    const svg = document.querySelector('.svg');
    const sectionContainer = document.getElementById(
      'steps-animation-container-placeholder',
    );

    if (window.matchMedia('(min-width: 1024px)').matches && sectionContainer) {
      const bottom = sectionContainer.getBoundingClientRect().height - window.innerHeight;

      gsap.to(progressBar, {
        height: '100%',
        scrollTrigger: {
          trigger: '.effortless-section',
          start: 'top 200px',
          end: `${bottom + 200 > 0 ? 'bottom' : bottom + 200 + 'px'} top`,
          scrub: true,
          pin: true,
          onUpdate: (self) => {
            const progress = Math.round(self.progress * 100);

            if (
              progressBar &&
              progressBar.style &&
              progressBar.style.height &&
              progressBar.style.height !== `${progress}%`
            ) {
              progressBar.style.height = `${progress}%`;
            }

            if (asset1 && progress > 50) {
              asset1.classList.add('halfway');
              asset2.classList.add('halfway');
            } else if (asset1) {
              asset1.classList.remove('halfway');
              asset2.classList.remove('halfway');
            }

            if (svgContainer && progress === 100) {
              svgContainer.classList.add('complete');
              svg.classList.add('complete');
            } else if (svgContainer && svg) {
              svgContainer.classList.remove('complete');
              svg.classList.remove('complete');
            }
          },
        },
      });
    } else {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    }
  },

  handleResize() {
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    this.setupScrollTriggers();
  },
};
